import { lazy } from 'react';
// project import
import { RequireAuthentication } from '../guards/RequireAuthentication';
import MainLayout from '../../layout/main-layout/MainLayout';
import Loadable from '../../components/Loadable';
import drones from './drones';
import notfound from './notfound';
import api_controller from './api-controller';
import mission from './mission';
import detector from './detector';

// import dashboard from './nostradamus/dashboard';
import fire_damage from './nostradamus/fire-damage';
import military_surveillance from './nostradamus/military-surveillance';
import unmanned_aerial_vehicles from './nostradamus/unmanned-aerial-vehicles';
import shelling from './nostradamus/shelling';
import profile from './nostradamus/profile';
import administration from './nostradamus/administration';
import moral_psychological_support from './nostradamus/moral-psychological-support';
import crowdsource from './nostradamus/crowdsource';
import bellingcat_events from './nostradamus/bellingcat-events';
import managed_assets from './nostradamus/managed-assets';

const HomePage = Loadable(
    lazy(() => import('../../pages/home/HomePage'))
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <RequireAuthentication>
            <MainLayout />
        </RequireAuthentication>
    ),
    children: [
        {
            path: 'portal',
            element: <HomePage />,
        },
        drones,
        notfound,
        api_controller,
        mission,
        detector,
        // dashboard,
        fire_damage,
        military_surveillance,
        unmanned_aerial_vehicles,
        shelling,
        profile,
        administration,
        moral_psychological_support,
        crowdsource,
        bellingcat_events,
        managed_assets,
    ],
};

export default MainRoutes;
